import { render } from "./index.vue?vue&type=template&id=254dd092&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=254dd092&lang=less&scoped=true"

import exportComponent from "/Users/xiaobiaoza/Desktop/workspace/GIM/WPP/wpp-aigc-aigc-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254dd092"],['__file',"src/components/surnameAvatar/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "254dd092"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('254dd092', __exports__)) {
    console.log('reload')
    api.reload('254dd092', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=254dd092&scoped=true", () => {
    console.log('re-render')
    api.rerender('254dd092', render)
  })

}


export default __exports__